import React, { forwardRef } from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts/highmaps";
import styles from "./HighChartsMap.module.scss";
// import IranMap from '@highcharts/map-collection/countries/ir/ir-all.geo.json';
import IranMap from "./mapp.json";
const HighChartsMap = forwardRef(({ options, chartRef }) => {
  const customData = { ...options, chart: { map: IranMap } };

  return (
    <div className={styles.container}>
      <HighchartsReact
        highcharts={Highcharts}
        options={customData}
        constructorType={"mapChart"}
        updateArgs={[true, true, false]}
        ref={chartRef}
      />
    </div>
  );
});

export default HighChartsMap;
